import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyStatusBadge = ({ status, size = 'default' }) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  const statusConfig = {
    active: {
      bg: 'bg-success/10',
      text: 'text-success',
      border: 'border-success/20',
      icon: 'CheckCircle2',
      label: 'Active'
    },
    inactive: {
      bg: 'bg-muted',
      text: 'text-text-secondary',
      border: 'border-border',
      icon: 'XCircle',
      label: 'Inactive'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.inactive;

  return (
    <span className={`inline-flex items-center gap-1.5 ${sizeClasses?.[size]} ${config?.bg} ${config?.text} border ${config?.border} rounded-full font-medium`}>
      <Icon name={config?.icon} size={size === 'sm' ? 12 : 14} />
      {config?.label}
    </span>
  );
};

export default CompanyStatusBadge;